<template>
    <div class="news-detail-page">
        <HeaderPc />
        <div class="page-container">
            <div class="container">
                <!-- 主内容 -->
                <div class="main-content">
                    <div class="breadcrumb">
                        <span @click="$router.push('/')">首页</span>
                        <i class="el-icon-arrow-right"></i>
                        <span @click="$router.push('/news?type=' + (detail.type == 1 ? 2 : 1))">
                            {{ detail.type === 1 ? '通知公告' : '市场动态' }}
                        </span>
                        <i class="el-icon-arrow-right"></i>
                        <span class="current">{{ detail.title }}</span>
                    </div>

                    <div class="detail-card" v-loading="loading">
                        <template v-if="detail.id">
                            <h1 class="detail-title">{{ detail.title }}</h1>
                            <div class="detail-meta">
                                <span><i class="el-icon-time"></i> {{ detail.create_time }}</span>
                                <span class="type-tag" :class="detail.type === 2 ? 'tag-notice' : 'tag-market'">
                                    {{ detail.type === 1 ? '通知公告' : '市场动态' }}
                                </span>
                            </div>
                            <div class="divider"></div>
                            <div class="detail-content" v-html="detail.content"></div>
                        </template>
                        <div class="empty-state" v-else-if="!loading">
                            <i class="el-icon-document-delete"></i>
                            <p>内容不存在或已删除</p>
                            <el-button type="primary" size="small" @click="$router.back()">返回</el-button>
                        </div>
                    </div>

                    <!-- 上一篇/下一篇 -->
                    <div class="nav-articles" v-if="detail.id">
                        <div class="nav-item" @click="goDetail(detail.prev_id)" v-if="detail.prev_id">
                            <span class="nav-label">上一篇</span>
                            <span class="nav-title">{{ detail.prev_title }}</span>
                        </div>
                        <div class="nav-item nav-right" @click="goDetail(detail.next_id)" v-if="detail.next_id">
                            <span class="nav-label">下一篇</span>
                            <span class="nav-title">{{ detail.next_title }}</span>
                        </div>
                    </div>
                </div>

                <!-- 侧边栏 -->
                <div class="sidebar">
                    <div class="sidebar-block">
                        <div class="sidebar-title">
                            <i class="el-icon-s-flag"></i> 通知公告
                        </div>
                        <div
                            class="sidebar-item"
                            v-for="item in noticeList"
                            :key="item.id"
                            :class="{ 'sidebar-item-active': item.id === detail.id }"
                            @click="goDetail(item.id)"
                        >
                            <span class="dot"></span>
                            <span class="sidebar-item-title">{{ item.title }}</span>
                        </div>
                        <div class="sidebar-empty" v-if="noticeList.length === 0">暂无公告</div>
                    </div>
                    <div class="sidebar-block">
                        <div class="sidebar-title">
                            <i class="el-icon-data-line"></i> 市场动态
                        </div>
                        <div
                            class="sidebar-item"
                            v-for="item in marketList"
                            :key="item.id"
                            :class="{ 'sidebar-item-active': item.id === detail.id }"
                            @click="goDetail(item.id)"
                        >
                            <span class="dot"></span>
                            <span class="sidebar-item-title">{{ item.title }}</span>
                        </div>
                        <div class="sidebar-empty" v-if="marketList.length === 0">暂无动态</div>
                    </div>
                </div>
            </div>
        </div>
        <FooterPc />
    </div>
</template>

<script>
import HeaderPc from '@/components/pc/header.vue';
import FooterPc from '@/components/pc/fotter.vue';
import { getNewsDetail, getNewsList } from '@/api/news';

export default {
    name: 'NewsDetail',
    components: { HeaderPc, FooterPc },
    data() {
        return {
            detail: {},
            loading: false,
            noticeList: [],
            marketList: []
        };
    },
    created() {
        this.fetchDetail();
        this.fetchSidebar();
    },
    watch: {
        '$route.params.id'() {
            this.fetchDetail();
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
    },
    methods: {
        fetchDetail() {
            this.loading = true;
            this.detail = {};
            getNewsDetail(this.$route.params.id)
                .then(res => {
                    if (res.code) this.detail = res.data || {};
                })
                .finally(() => { this.loading = false; });
        },
        fetchSidebar() {
            getNewsList({ type: 2, page: 1, limit: 8 }).then(res => {
                if (res.code) this.noticeList = res.data.list || [];
            });
            getNewsList({ type: 1, page: 1, limit: 8 }).then(res => {
                if (res.code) this.marketList = res.data.list || [];
            });
        },
        goDetail(id) {
            if (!id) return;
            this.$router.push(`/news/${id}`);
        }
    }
};
</script>

<style scoped>
.news-detail-page {
    min-height: 100vh;
    background: #f5f5f5;
}
.page-container {
    padding: 20px 0 40px;
}
.container {
    width: 80%;
    margin: 0 auto;
    display: flex;
    gap: 20px;
    align-items: flex-start;
}

/* 面包屑 */
.breadcrumb {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 13px;
    color: #888;
    margin-bottom: 12px;
}
.breadcrumb span { cursor: pointer; }
.breadcrumb span:hover { color: #e1251b; }
.breadcrumb .current { color: #333; cursor: default; }
.breadcrumb i { font-size: 11px; color: #ccc; }

/* 主内容 */
.main-content { flex: 1; min-width: 0; }

.detail-card {
    background: #fff;
    border-radius: 8px;
    padding: 30px 36px;
    box-shadow: 0 2px 8px rgba(0,0,0,0.05);
    min-height: 300px;
}
.detail-title {
    font-size: 22px;
    font-weight: 700;
    color: #1f2937;
    margin: 0 0 16px;
    line-height: 1.5;
}
.detail-meta {
    display: flex;
    align-items: center;
    gap: 20px;
    font-size: 13px;
    color: #aaa;
    margin-bottom: 16px;
}
.detail-meta i { margin-right: 4px; }
.type-tag {
    padding: 2px 10px;
    border-radius: 10px;
    font-size: 12px;
    font-weight: 500;
}
.tag-notice { background: #fff3e0; color: #e65100; }
.tag-market { background: #e3f2fd; color: #1565c0; }
.divider {
    height: 1px;
    background: #f0f0f0;
    margin-bottom: 24px;
}
.detail-content {
    font-size: 15px;
    color: #333;
    line-height: 1.9;
}
.detail-content >>> img { max-width: 100%; border-radius: 6px; margin: 8px 0; }
.detail-content >>> p { margin: 0 0 12px; }
.detail-content >>> h2, .detail-content >>> h3 { color: #1f2937; margin: 20px 0 10px; }

/* 上下篇 */
.nav-articles {
    display: flex;
    justify-content: space-between;
    margin-top: 16px;
    background: #fff;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 2px 8px rgba(0,0,0,0.05);
}
.nav-item {
    flex: 1;
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 14px 20px;
    cursor: pointer;
    transition: background 0.2s;
    border-right: 1px solid #f5f5f5;
}
.nav-item:last-child { border-right: none; }
.nav-item:hover { background: #fff5f5; }
.nav-item:hover .nav-title { color: #e1251b; }
.nav-right { justify-content: flex-end; }
.nav-label {
    font-size: 12px;
    color: #aaa;
    flex-shrink: 0;
    background: #f5f5f5;
    padding: 2px 8px;
    border-radius: 4px;
}
.nav-title {
    font-size: 13px;
    color: #444;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    transition: color 0.2s;
}

/* 空状态 */
.empty-state {
    text-align: center;
    padding: 60px 0;
    color: #94a3b8;
}
.empty-state i { font-size: 48px; margin-bottom: 12px; color: #cbd5e1; display: block; }
.empty-state p { margin: 0 0 16px; font-size: 14px; }

/* 侧边栏 */
.sidebar {
    width: 260px;
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    gap: 16px;
}
.sidebar-block {
    background: #fff;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 2px 8px rgba(0,0,0,0.05);
}
.sidebar-title {
    padding: 12px 16px;
    font-size: 14px;
    font-weight: 600;
    color: #fff;
    background: #e1251b;
    display: flex;
    align-items: center;
    gap: 6px;
}
.sidebar-item {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 10px 16px;
    border-bottom: 1px solid #f5f5f5;
    cursor: pointer;
    transition: background 0.2s;
}
.sidebar-item:last-child { border-bottom: none; }
.sidebar-item:hover, .sidebar-item-active { background: #fff5f5; }
.sidebar-item:hover .sidebar-item-title,
.sidebar-item-active .sidebar-item-title { color: #e1251b; }
.dot {
    width: 6px; height: 6px;
    border-radius: 50%;
    background: #e1251b;
    flex-shrink: 0;
}
.sidebar-item-title {
    font-size: 13px;
    color: #444;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    transition: color 0.2s;
}
.sidebar-empty {
    padding: 16px;
    font-size: 13px;
    color: #aaa;
    text-align: center;
}
</style>
